export const ISSUE_ATTRIBUTES_FETCH_START = 'ISSUE_ATTRIBUTES_FETCH_START';
export const ISSUE_ATTRIBUTES_FETCH_API = 'ISSUE_ATTRIBUTES_FETCH_API';
export const ISSUE_ATTRIBUTES_FETCH_API_FULFILLED = 'ISSUE_ATTRIBUTES_FETCH_API_FULFILLED';
export const ISSUE_ATTRIBUTES_FETCH_API_REJECTED = 'ISSUE_ATTRIBUTES_FETCH_API_REJECTED';
export const ISSUE_ATTRIBUTES_DEFINITIONS_FETCH_FINISHED = 'ISSUE_ATTRIBUTES_DEFINITIONS_FETCH_FINISHED';

export const ISSUE_ATTRIBUTES_CREATE_START = 'ISSUE_ATTRIBUTES_CREATE_START';
export const ISSUE_ATTRIBUTES_CREATE_API = 'ISSUE_ATTRIBUTES_CREATE_API';
export const ISSUE_ATTRIBUTES_CREATE_API_FULFILLED = 'ISSUE_ATTRIBUTES_CREATE_API_FULFILLED';
export const ISSUE_ATTRIBUTES_CREATE_API_REJECTED = 'ISSUE_ATTRIBUTES_CREATE_API_REJECTED';

export const ISSUE_ATTRIBUTES_MAPPINGS_FETCH_START = 'ISSUE_ATTRIBUTES_MAPPINGS_FETCH_START';
export const ISSUE_ATTRIBUTES_MAPPINGS_FETCH_API = 'ISSUE_ATTRIBUTES_MAPPINGS_FETCH_API';
export const ISSUE_ATTRIBUTES_MAPPINGS_FETCH_API_FULFILLED = 'ISSUE_ATTRIBUTES_MAPPINGS_FETCH_API_FULFILLED';
export const ISSUE_ATTRIBUTES_MAPPINGS_FETCH_API_REJECTED = 'ISSUE_ATTRIBUTES_MAPPINGS_FETCH_API_REJECTED';
export const ISSUE_ATTRIBUTES_MAPPINGS_FETCH_FINISHED = 'ISSUE_ATTRIBUTES_MAPPINGS_FETCH_FINISHED';

export const ISSUE_ATTRIBUTES_UPDATE_START = 'ISSUE_ATTRIBUTES_UPDATE_START';
export const ISSUE_ATTRIBUTES_UPDATE_API = 'ISSUE_ATTRIBUTES_UPDATE_API';
export const ISSUE_ATTRIBUTES_UPDATE_API_FULFILLED = 'ISSUE_ATTRIBUTES_UPDATE_API_FULFILLED';
export const ISSUE_ATTRIBUTES_UPDATE_API_REJECTED = 'ISSUE_ATTRIBUTES_UPDATE_API_REJECTED';

export const ISSUE_ATTRIBUTES_DELETE_START = 'ISSUE_ATTRIBUTES_DELETE_START';
export const ISSUE_ATTRIBUTES_DELETE_API = 'ISSUE_ATTRIBUTES_DELETE_API';
export const ISSUE_ATTRIBUTES_DELETE_API_FULFILLED = 'ISSUE_ATTRIBUTES_DELETE_API_FULFILLED';
export const ISSUE_ATTRIBUTES_DELETE_API_REJECTED = 'ISSUE_ATTRIBUTES_DELETE_API_REJECTED';

export const ISSUE_ATTRIBUTES_EDIT_START = 'ISSUE_ATTRIBUTES_EDIT_START';
export const ISSUE_ATTRIBUTES_EDIT_END = 'ISSUE_ATTRIBUTES_EDIT_END';

export const ISSUE_ATTRIBUTES_MAPPINGS_UPDATE_START = 'ISSUE_ATTRIBUTES_MAPPINGS_UPDATE_START';
export const ISSUE_ATTRIBUTES_MAPPINGS_UPDATE_API = 'ISSUE_ATTRIBUTES_MAPPINGS_UPDATE_API';
export const ISSUE_ATTRIBUTES_MAPPINGS_UPDATE_API_FULFILLED = 'ISSUE_ATTRIBUTES_MAPPINGS_UPDATE_API_FULFILLED';
export const ISSUE_ATTRIBUTES_MAPPINGS_UPDATE_API_REJECTED = 'ISSUE_ATTRIBUTES_MAPPINGS_UPDATE_API_REJECTED';

export const ISSUE_ATTRIBUTES_MAPPINGS_SET = 'ISSUE_ATTRIBUTES_MAPPINGS_SET';

export const ISSUE_ATTRIBUTES_RESET_HIGHLIGHTING_ROWS = 'ISSUE_ATTRIBUTES_RESET_HIGHLIGHTING_ROWS';
export const SHOW_ISSUE_ATTRIBUTES_MODAL = 'SHOW_ISSUE_ATTRIBUTES_MODAL';

export const fetchIssueAttributesDefinitionsAction = (offset = 0) => ({
  type: ISSUE_ATTRIBUTES_FETCH_START,
  payload: {offset}
});

export const fetchIssueAttributesDefinitionsFinishedAction = () => ({
  type: ISSUE_ATTRIBUTES_DEFINITIONS_FETCH_FINISHED
});

export const fetchIssueAttributesMappingsAction = (offset = 0) => ({
  type: ISSUE_ATTRIBUTES_MAPPINGS_FETCH_START,
  payload: {offset}
});

export const fetchIssueAttributesMappingsFinishedAction = () => ({
  type: ISSUE_ATTRIBUTES_MAPPINGS_FETCH_FINISHED
});

export const createIssueAttributeAction = (changeObject, meta) => ({
  type: ISSUE_ATTRIBUTES_CREATE_START,
  payload: changeObject,
  meta
});

export const updateIssueAttributeAction = (changeObject, meta) => ({
  type: ISSUE_ATTRIBUTES_UPDATE_START,
  payload: changeObject,
  meta
});

export const deleteIssueAttributeAction = (id, title, meta) => ({
  type: ISSUE_ATTRIBUTES_DELETE_START,
  payload: id,
  meta: {id, title, ...meta}
});

export const resetHighlightingRowsAction = () => ({
  type: ISSUE_ATTRIBUTES_RESET_HIGHLIGHTING_ROWS
});

export const editIssueAttribute = id => ({
  type: ISSUE_ATTRIBUTES_EDIT_START,
  payload: id
});

export const resetEditingIssueAttributeId = () => ({
  type: ISSUE_ATTRIBUTES_EDIT_END
});

export const updateIssueTypeAttributesAction = (issueTypeForEdit, onSuccess) => ({
  type: ISSUE_ATTRIBUTES_MAPPINGS_UPDATE_START,
  payload: {
    id: issueTypeForEdit.id,
    parentId: issueTypeForEdit.parentId,
    isContainerType: issueTypeForEdit.isContainerType,
    onSuccess
  }
});

export const showNewIssueAttributeModalAction = visible => ({
  type: SHOW_ISSUE_ATTRIBUTES_MODAL,
  payload: {visible}
});
